import api from './api';

const badgeService = {
    // Alle verfügbaren Badges abrufen
    getAllBadges: async () => {
        console.log('[badgeService.getAllBadges] API-Call: GET /badges');
        try {
            const response = await api.get('/badges');
            console.log('[badgeService.getAllBadges] ✅ Response:', response);
            console.log('[badgeService.getAllBadges] Response.data:', response.data);
            return response.data;
        } catch (error) {
            console.error('[badgeService.getAllBadges] ❌ Error:', error);
            console.error('[badgeService.getAllBadges] Error Response:', error.response);
            throw error;
        }
    },

    // Badges eines Mitglieds abrufen
    getMemberBadges: async (memberId) => {
        console.log('[badgeService.getMemberBadges] API-Call: GET /api/members/' + memberId + '/badges');
        try {
            const response = await api.get(`/api/members/${memberId}/badges`);
            console.log('[badgeService.getMemberBadges] ✅ Response:', response.data);
            return response.data;
        } catch (error) {
            console.error('[badgeService.getMemberBadges] ❌ Error:', error);
            throw error;
        }
    },

    // Badge an Mitglied verleihen
    awardBadge: async (memberId, badgeData) => {
        console.log('[badgeService.awardBadge] === VERLEIHE BADGE ===');
        console.log('[badgeService.awardBadge] Member ID:', memberId);
        console.log('[badgeService.awardBadge] Badge Data:', badgeData);
        console.log('[badgeService.awardBadge] API-Call: POST /api/members/' + memberId + '/badges');

        try {
            const response = await api.post(`/api/members/${memberId}/badges`, badgeData);
            console.log('[badgeService.awardBadge] ✅ Response:', response);
            console.log('[badgeService.awardBadge] Response Data:', response.data);
            return response.data;
        } catch (error) {
            console.error('[badgeService.awardBadge] ❌ Error:', error);
            console.error('[badgeService.awardBadge] Error Response:', error.response);
            throw error;
        }
    },

    // Badge-Verleihung aktualisieren
    updateMemberBadge: async (memberId, memberBadgeId, badgeData) => {
        const response = await api.put(`/api/members/${memberId}/badges/${memberBadgeId}`, badgeData);
        return response.data;
    },

    // Badge von Mitglied entfernen
    removeMemberBadge: async (memberId, memberBadgeId) => {
        const response = await api.delete(`/api/members/${memberId}/badges/${memberBadgeId}`);
        return response.data;
    },
};

export default badgeService;

